import { createGlobalStyle } from 'styled-components'
import type { DefaultTheme } from 'styled-components'

const neutralGrey600 = '#757575'
const neutralBlack800 = '#1C1D22'

export const lightTheme: DefaultTheme = {
  colors: {
    primary: neutralBlack800,
    primaryHover: neutralGrey600,
    primaryBtnTxt: '#FDFDFD',
    toggleUnselected: '#F5F5F5',
    toggleHover: '#E0E0E0',
    kanbanColumn: '#F9F9F9',
    kanbanCard: '#FFFFFF',
    kanbanCardTitle: neutralBlack800,
    pageBg: '#EEEEEE',
    greetingText: neutralBlack800,
    greetingName: neutralGrey600,
  },
  filters: {
    primaryIcon: 'invert(100%) brightness(115%) contrast(100%)',
  },
}

export const darkTheme: DefaultTheme = {
  colors: {
    primaryBtnBg: '#0D47A1',
  },
}

const windowWidth = window.innerWidth
const windowHeight = window.innerHeight

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    font-family: 'Roboto';
    box-sizing: border-box;
  }

	body {
    max-width: 100vw;
    width: 100vw;
    max-height: 100vh;
    height: 100vh;
    overflow: auto;
    .mobile-message {
      display: none;
    }

    width: ${windowWidth};
    height: ${windowHeight};
    background: '#F5F5F5';


    overflow: hidden;

    @media only screen and (max-width: 768px) {
      #root {
        display: none;
      } 

       .mobile-message {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background-color: #f8d7da; 
        color: #721c24; 
        padding: 20px;
        margin: 20px;
        border-radius: 5px;
        text-align: center;
        font-family: 'Roboto';
      } 
    }
	}

  a {
    display: flex;
    justify-content: center;
    text-decoration: none;
  }
`
